import { render, staticRenderFns } from "./NfInput.vue?vue&type=template&id=a6e00bd2&scoped=true&"
import script from "./NfInput.vue?vue&type=script&lang=js&"
export * from "./NfInput.vue?vue&type=script&lang=js&"
import style0 from "./NfInput.vue?vue&type=style&index=0&id=a6e00bd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e00bd2",
  null
  
)

export default component.exports